import { Avatar, Column, Label } from '@tempmee/react';
import { getOfficeAvatarUrl } from '~/utils/OfficeUtils';

interface IProps {
  profileImage: string;
  size: '2xl' | 'xl';
  showAdminLabel: boolean;
}

export const OfficeAvatar = ({ profileImage, size, showAdminLabel }: IProps) => (
  <Column align="center">
    <Avatar src={getOfficeAvatarUrl(profileImage)} size={size} alt="profile image" />
    {showAdminLabel && (
      <div style={{ marginTop: -10, alignSelf: 'center', zIndex: 4 }}>
        <Label severity="brand" variant="filled">
          ADMIN
        </Label>
      </div>
    )}
  </Column>
);
